import * as React from "react";
import { useCollaborateStore } from "../store/useCollaborateStore";
import type { CollaborateUserProfile, Thread } from "../types/collaborateThread";
import { applyCollaborateThreadFilters } from "../utils/threadFilters";

/** Stable thread list — do not use getThreadsOrdered() in a Zustand selector (new array every time). */
export function useOrderedThreads(): Thread[] {
  const threadIds = useCollaborateStore((s) => s.threadIds);
  const threadsById = useCollaborateStore((s) => s.threadsById);
  const listView = useCollaborateStore((s) => s.listView);
  const versionFilter = useCollaborateStore((s) => s.versionFilter);
  const currentUserId = useCollaborateStore((s) => s.currentUserId);
  return React.useMemo(() => {
    const ordered = threadIds
      .map((id) => threadsById[id])
      .filter((t): t is Thread => Boolean(t));
    return applyCollaborateThreadFilters(ordered, listView, versionFilter, currentUserId);
  }, [threadIds, threadsById, listView, versionFilter, currentUserId]);
}

/** Stable user list for mention editor. */
export function useCollaborateUserList(): CollaborateUserProfile[] {
  const usersById = useCollaborateStore((s) => s.usersById);
  return React.useMemo(() => Object.values(usersById), [usersById]);
}
